import {
  getFindVenueOverviewVersionQueryKey,
  useUpdateVenueOverviewVersion,
} from '@api';
import { useInvalidateQuery, useNotification } from '@common';
import { AxiosError } from 'axios';
import { VenueSurchargesFormDataType } from '../useVenueSurchargesFormSchema';

const TRANS_PATH = 'NOTIFICATIONS.UPDATE_VENUE_SURCHARGES';

type UseUpdateVenueSurchargesReturnType = {
  updateVenueSurcharges: (data: VenueSurchargesFormDataType) => Promise<void>;
};

type UseUpdateVenueSurchargesPropsType = {
  venueId: string;
  overviewVersion: string;
  onClose: () => void;
};

export const useUpdateVenueSurcharges = ({
  venueId,
  overviewVersion,
  onClose,
}: UseUpdateVenueSurchargesPropsType): UseUpdateVenueSurchargesReturnType => {
  const { mutateAsync } = useUpdateVenueOverviewVersion();
  const { showSuccess, showError } = useNotification();

  const { invalidateQuery } = useInvalidateQuery(
    getFindVenueOverviewVersionQueryKey(venueId, overviewVersion)
  );

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH}.SUCCESS.TITLE`,
      message: `${TRANS_PATH}.SUCCESS.MESSAGE`,
    });
    invalidateQuery();
    onClose();
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH}.ERROR.TITLE`,
      message: `${TRANS_PATH}.ERROR.MESSAGE`,
      error,
    });
  };

  const updateVenueSurcharges = async (data: VenueSurchargesFormDataType): Promise<void> => {
    await mutateAsync(
      {
        venueId,
        overviewVersion,
        data: { venueSurcharges: data },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { updateVenueSurcharges };
};
